import { postNotificationAdminBulk } from '@/services/api/requests/notifications';
import { TNotificationForm } from '@/validation/notification';
import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import { ENotificationTargetTypes } from '@/constants/stringVars';

const useSendNotificationToUsers = (onSuccessCallback?: () => void) => {
  const toast = useToast();

  const { mutate, isPending } = useMutation({
    mutationFn: async ({ form, userIds }: { form: TNotificationForm; userIds: Array<string> }) => {
      const response = await postNotificationAdminBulk({
        form,
        options: {
          targetType: ENotificationTargetTypes.SPECIFIC_USERS,
          userIds,
        },
      });
      return response;
    },
    onSuccess: () => {
      toast({
        title: 'Notification sent successfully',
        description: 'The notification has been sent to the selected user(s).',
        status: 'success',
        duration: 3000,
      });

      onSuccessCallback?.();
    },
    onError: (error) => {
      toast({
        title: 'Error sending notification',
        description: error?.message || 'An error occurred while sending the notification.',
        status: 'error',
        duration: 3000,
      });
    },
  });

  return { mutate, isPending };
};

export default useSendNotificationToUsers;
